import type { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

export function setupRequestInterceptor(instance: AxiosInstance): void {
  instance.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      // Authentication is handled automatically via HttpOnly cookies.
      // Do NOT inject Authorization headers manually.
      return config;
    },
    (error) => Promise.reject(error),
  );
}
